// 현장/스케줄 상태 라벨·톤 — 스케줄 관리 화면들의 우측 현장 패널(RightPanel, SchedulerPage.tsx)과
// 현장 관리 목록(SiteListView.tsx)이 서로 다른 매핑을 따로 들고 있다가 어긋난 적이 있어
// (SiteListView는 DELAYED·COMPLETED를 몰라 원본 코드값이 그대로 노출됨) 한 곳으로 합쳤다.
// 라벨은 공통코드(E01_SCHEDULE_STATUS, CommonCodesContext의 siteStatuses)가 SSOT이고,
// 여기 라벨은 조회 전/실패 시에만 쓰는 폴백이다. 색상 톤은 공통코드에 없는 값이라 코드값
// 기준으로 이 맵에 고정한다(디자인 결정, DB로 바뀌지 않음).
export type SiteStatusTone = 'info' | 'warning' | 'success' | 'danger'

export const SITE_STATUS_MAP: Record<string, { label: string; status: SiteStatusTone }> = {
  READY:       { label: '준비중',   status: 'info'    },
  IN_PROGRESS: { label: '시공중',   status: 'warning' },
  DONE:        { label: '시공완료', status: 'success' },
  COMPLETED:   { label: '시공완료', status: 'success' },
  DELAYED:     { label: '지연',     status: 'danger'  },
}

/**
 * @param code 스케줄/현장 상태 코드값(READY 등)
 * @param liveLabel 공통코드 조회분에서 찾은 codeName — 있으면 이 라벨을 우선 사용한다
 */
export function getSiteStatusBadge(code: string, liveLabel?: string): { label: string; status: SiteStatusTone } {
  return {
    label:  liveLabel || SITE_STATUS_MAP[code]?.label || code || '시공중',
    status: SITE_STATUS_MAP[code]?.status ?? 'warning',
  }
}
